module.exports = __webpack_public_path__ + "img/img39.b51a9105.svg";